import React from "react"

class ListDynamic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            status : ""
        }
    }
    componentWillReceiveProps(props){
        const status = props.status;
        this.setState({
            status : status
        })
    }
    render = () => (
        <table className={"list-reports " + this.state.status}>
            <tr>
                <td>
                    <span className="title-report">E-COMMERCE ADVENTURE PARK VALLARTA</span>
                    <div>
                        <span>Created at: 14-May-2018 | Analysis interval: 7 days</span>
                        <span>Next shipment: 21-May-2018</span>
                    </div>
                </td>
                <td>
                    <span className=""><a className="share"></a>{10}</span>
                    <a className="edit"></a>
                    <a className="remove"></a>
                </td>
            </tr>
            <tr>
                <td>
                    <span className="title-report">REPORT EXTREME PARKLAND VALLARTA</span>
                    <div>
                        <span>Created at: 14-May-2018 | Analysis interval: 7 days</span>
                        <span>Next shipment: 21-May-2018</span>
                    </div>
                </td>
                <td>
                    <span className=""><a className="share"></a>{10}</span>
                    <a className="edit"></a>
                    <a className="remove"></a>
                </td>
            </tr>
            <tr>
                <td>
                    <span className="title-report">REPORT ADVENTURE PARK VALLARTA</span>
                    <div>
                        <span>Created at: 14-May-2018 | Analysis interval: 7 days</span>
                        <span>Next shipment: 21-May-2018</span>
                    </div>
                </td>
                <td>
                    <span className=""><a className="share"></a>{10}</span>
                    <a className="edit"></a>
                    <a className="remove"></a>
                </td>
            </tr>
        </table>
    )
}

export default ListDynamic;


// WEBPACK FOOTER //
// ./src/Frontend/reports/ListDynamic.js